/**
 *
 *  Partners By Specialisation Scroller for Homepage
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 19/10/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { useAppState } from "../../../state";

// Components
import ContentScroller from "../../ContentScroller/ContentScroller";
import PrevButton from "../../TruBeDateTimePicker/PrevButton/PrevButton";
import NextButton from "../../TruBeDateTimePicker/NextButton/NextButton";
// import TrainerCard from "./TrainerCard/TrainerCard";
import TrainerCardPlaceholder from "./TrainerCardPlaceholder/TrainerCardPlaceholder";

// Hooks
import useButtonsHidden from "../../TruBeDateTimePicker/useButtonsHidden/useButtonsHidden";
import useContentScrollerControls from "../../../hooks/useContentScrollerControls/useContentScrollerControls";
import useForwardRef from "../../../hooks/useForwardRef/useForwardRef";
import useTheme from "../../ThemeProvider/useTheme/useTheme";
import useDeviceCapabilities from "../../../hooks/useDeviceCapabilities/useDeviceCapabilities";
import { useEvent } from "../../../hooks/useEvent/useEvent";

// Utils
// import { clientWidth } from "../../../utils";
import { getScrollTarget } from "../../../utils/getScrollTarget";
import { PARTNERS_PAGE_SIZE } from "../../../constants";

let placeholders = [];

for (var i = 0; i < PARTNERS_PAGE_SIZE; i++) {
  placeholders.push(i);
}

export default function PartnersScroller({ partners, renderPartner }) {
  // const location = useLocation();
  //
  // const { theme } = useTheme();

  const {
    // user,
    isFetching,
  } = useAppState();

  const { supportsTouchCapableExperience } = useDeviceCapabilities(),
    [_supportsTouchCapableExperience, setSupportsTouchCapableExperience] =
      useState(supportsTouchCapableExperience ? 1 : 0);

  useEffect(() => {
    setSupportsTouchCapableExperience(supportsTouchCapableExperience ? 1 : 0);
  }, [supportsTouchCapableExperience]);

  const contentScrollerRef = useRef(null),
    [_contentScrollerRef, setContentScrollerRef] =
      useForwardRef(contentScrollerRef);

  const recalcReset = useEvent(() => {
    _contentScrollerRef &&
      _contentScrollerRef.recalc({
        reason: "reset",
      });
  });

  useEffect(() => {
    _contentScrollerRef && recalcReset();
  }, [recalcReset, _contentScrollerRef]);

  const recalcChildrenChangedEvent = useEvent(() => {
    _contentScrollerRef &&
      setTimeout(() =>
        _contentScrollerRef.recalc({
          reason: "children_changed",
        })
      );
  });

  useEffect(() => {
    _contentScrollerRef &&
      _supportsTouchCapableExperience > 0 &&
      recalcChildrenChangedEvent();
  }, [
    recalcChildrenChangedEvent,
    _contentScrollerRef,
    _supportsTouchCapableExperience,
  ]);

  const [hiddenPrev, hiddenNext] = useButtonsHidden({
      contentScrollerApi: _contentScrollerRef,
      itemCount: partners.length,
      isLoading: isFetching,
    }),
    { onPressForward, onPressReverse } = useContentScrollerControls({
      contentScrollerApi: _contentScrollerRef,
      loop: false,
      unit: "slide",
      getScrollTarget,
    });

  // useEffect(() => {
  //   _contentScrollerRef &&
  //   (onScrollerMounted == null || onScrollerMounted(_contentScrollerRef));
  // }, [onScrollerMounted, _contentScrollerRef]);

  // React.useEffect(() => {
  //   loadAvailablePartnersBySpecialisation("LIFESTYLE");
  // }, [user]);

  const handleCardVisibleChange = useCallback((key, inView, element) => {
    // console.log("onCardVisibleChange", key, inView, element);
  }, []);

  return (
    <div
      className={`partners-by-specialisation${
        hiddenPrev || partners.length < 2 ? " hidden-prev" : ""
      }${hiddenNext || partners.length < 2 ? " hidden-next" : ""}`}
    >
      <ContentScroller
        autoRecalcOnMount={false}
        controls={
          !isFetching && (
            <PrevButton
              onPress={onPressReverse}
              className="md:tbk-bottom-2 md:tbk-left-0"
              buttonClassName="tbk-mb-40"
              visible={!hiddenPrev && partners.length > 1}
            />
          )
        }
        trailingControls={
          !isFetching && (
            <NextButton
              onPress={onPressForward}
              className="md:tbk-bottom-2 md:tbk-right-0"
              buttonClassName="tbk-mb-40"
              visible={!hiddenNext && partners.length > 1}
            />
          )
        }
        description=""
        ref={setContentScrollerRef}
        ariaScrollerRole="radiogroup"
        style={{
          position: "relative",
          height: "380px", //isFetching ? "356px" : "356px", //"298px",
        }}
      >
        {isFetching
          ? placeholders.map((_, index) => (
              <TrainerCardPlaceholder className="tbk--mt-3_" key={index} />
            ))
          : partners.map((partner, index) =>
              renderPartner({
                index,
                info: partner,
                contentScrollerApi: _contentScrollerRef,
                onCardVisibleChange: handleCardVisibleChange,
              })
            )}
      </ContentScroller>
    </div>
  );
}
